export const programmaticallyDownloading = (href: string, name?: string) => {
  const a = document.createElement('a');
  a.href = href;
  if (typeof name === 'string') {
    a.download = name;
  }
  a.target = '_blank';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
